import { useEffect } from 'react';

import { useAuthStore } from '@/stores/authStore';
import { useUIStore } from '@/stores/uiStore';
import {
  getPermissionState,
  isPushSupported,
  subscribeToPush,
} from '@/lib/pushNotifications';

/**
 * After login, if the cashier has opted into push and the browser already
 * granted permission, re-confirm the subscription with the backend. This
 * covers two cases:
 *   - subscription was wiped (browser data cleared, new install)
 *   - server lost the row but the browser still has it
 *
 * The actual opt-in (which has to be inside a click handler) lives in the
 * Settings page. This hook just keeps things in sync.
 */
export function usePushSubscription() {
  const isAuthenticated = useAuthStore((s) => s.status === 'authenticated');
  const pushEnabled = useUIStore((s) => s.pushEnabled);

  useEffect(() => {
    if (!isAuthenticated || !pushEnabled || !isPushSupported()) return;
    if (getPermissionState() !== 'granted') return;

    void subscribeToPush().catch((err) => {
      console.warn('[push] resubscribe failed', err);
    });
  }, [isAuthenticated, pushEnabled]);
}
